import { StudentDataConsent } from "../../../Utilities";

export function summarize(
	studentDataConsent:
		| Pick<
				StudentDataConsent,
				| "allowPublishStudentWorkGeneral"
				| "allowPublishVisualMediaOfGuardianForPromotion"
				| "allowPublishVisualMediaOfStudentForPromotion"
				| "allowPublishVisualMediaOfStudentGeneral"
				| "allowShareInformationWithPearsonEdexcel"
				| "allowShareInformationWithIbOrganization"
				| "allowShareInformationWithOnlinePlatforms"
				| "allowBirthdayInCalendar"
				| "allowSendCalendarEvents"
				| "allowSendNewsletters"
		  >
		| null
		| undefined,
) {
	let numAllowed = 0;
	let numDenied = 0;

	if (studentDataConsent) {
		if (studentDataConsent.allowPublishStudentWorkGeneral) {
			numAllowed++;
		} else {
			numDenied++;
		}
		if (studentDataConsent.allowPublishVisualMediaOfGuardianForPromotion) {
			numAllowed++;
		} else {
			numDenied++;
		}
		if (studentDataConsent.allowPublishVisualMediaOfStudentForPromotion) {
			numAllowed++;
		} else {
			numDenied++;
		}
		if (studentDataConsent.allowPublishVisualMediaOfStudentGeneral) {
			numAllowed++;
		} else {
			numDenied++;
		}
		if (studentDataConsent.allowShareInformationWithPearsonEdexcel) {
			numAllowed++;
		} else {
			numDenied++;
		}
		if (studentDataConsent.allowShareInformationWithIbOrganization) {
			numAllowed++;
		} else {
			numDenied++;
		}
		if (studentDataConsent.allowShareInformationWithOnlinePlatforms) {
			numAllowed++;
		} else {
			numDenied++;
		}
		if (studentDataConsent.allowBirthdayInCalendar) {
			numAllowed++;
		} else {
			numDenied++;
		}
		if (studentDataConsent.allowSendCalendarEvents) {
			numAllowed++;
		} else {
			numDenied++;
		}
		if (studentDataConsent.allowSendNewsletters) {
			numAllowed++;
		} else {
			numDenied++;
		}
	}

	return { numAllowed, numDenied };
}
